import { combineReducers } from "redux";
import authentication from "./authentication/reducer";
import data from "./data/reducer";
import details from "./details/slice";
import { LOGOUT_SUCCESSFUL } from "./authentication/types";
import { initialState } from "./state";

const appReducer = combineReducers({
  authentication,
  data,
  details
});

/**
 * When we get a successful login, we want to clear some of the state saved in the redux store.
 * However, we want to keep the application and locale state,
 * therefore we copy this state and pass it to the appReducer, removing all other state.
 */
const rootReducer = (state, action) => {
  // To clear the redux store the most of the states are set to undefined which results in returning the default state
  // except locale and application: these two states are needed to perform a successful redirect to login screen after logging out
  if (action.type === LOGOUT_SUCCESSFUL) {
    return appReducer(initialState, action);
  }
  return appReducer(state, action);
};

export default rootReducer;
